module.exports = __webpack_public_path__ + "assets/img/XRP.55b4362b.png";